// Idun sets the session-token cookie on the host page. Read it before each call,
// because another tab can replace the token at any time.
const getSessionToken = () => document.cookie.match(/(?:^|; )session-token=([^;]*)/)?.[1];

/**
 * Adds the x-session-token header when the page has a session token.
 *
 * @param {Object} headers
 * @returns {Object}
 */
export const withSessionToken = (headers = {}) => {
  const token = getSessionToken();
  return token ? { ...headers, 'x-session-token': token } : headers;
};
